/*
 * Client-side CSV download.
 *
 * Used by the Export buttons on pages whose data is already in the browser. The
 * backend's /api/export/* endpoints are not an alternative here: they export a
 * SAVED report by id, so there is nothing to point them at for "the view I am
 * looking at right now".
 */

/**
 * RFC 4180 quoting. Skipping this is how a CSV export quietly corrupts itself —
 * a user called "Rahman, Md." or an app named `Say "hi"` shifts every column
 * after it on that row.
 */
function cell(value) {
    if (value == null) return "";
    const text = String(value);
    return /[",\n\r]/.test(text) ? `"${text.replace(/"/g, '""')}"` : text;
}

/**
 * @param {string} filename        without extension
 * @param {string[]} headers
 * @param {Array<Array>} rows
 */
export function downloadCsv(filename, headers, rows) {
    const body = [headers, ...rows].map((row) => row.map(cell).join(",")).join("\r\n");

    // The BOM makes Excel open UTF-8 correctly; without it, Bengali names and
    // anything accented arrive as mojibake.
    const blob = new Blob([`\uFEFF${body}`], { type: "text/csv;charset=utf-8;" });
    const url = URL.createObjectURL(blob);

    const link = document.createElement("a");
    link.href = url;
    link.download = `${filename}.csv`;
    document.body.appendChild(link);
    link.click();
    link.remove();

    // Revoking immediately can cancel the download in some browsers; a tick is
    // enough for the navigation to have started.
    window.setTimeout(() => URL.revokeObjectURL(url), 1000);
}
